export default "/images/9ed900e39d4e9ede69fd47febde1149f.avif";